<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">
            <template v-slot:[`item.createdAt`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYDateFormat(new Date(item.createdAt).getTime() + (60*420*1000)) }}
                </span>

                <span class="grey--text">
                    {{ $util.getHHSSDateFormat(new Date(item.createdAt).getTime() + (60*420*1000)) }}
                </span>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'WristbandTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory()
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('andamandaPay.wristbandTable.header.wristbandId'),
                    value: 'GiftCardNo',
                    sortable: false
                },
                {
                    text: this.$t('andamandaPay.wristbandTable.header.wristbandName'),
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('andamandaPay.wristbandTable.header.activationDate'),
                    value: 'createdAt'
                }
            ]
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
